/**
 * Actieve menu-staat in de header.
 *
 * WordPress zet .current-menu-item alleen bij de eerste paginalaad; na een
 * Barba-transitie zijn die classes verouderd. Dit module bepaalt het actieve
 * item opnieuw uit de URL en zet de classes, zodat de oranje balk onder de
 * nav (CSS, _header.css) altijd onder de juiste pagina staat.
 */
let initialized = false;

const STALE_CLASSES = ['current-menu-item', 'current_page_item', 'current-menu-parent'];

/**
 * Prefix-aliases voor paths die niet onder hun eigen menu-item vallen,
 * bv. categorie-archieven en losse producten onder "Products".
 */
const PREFIX_ALIASES = {
    '/products/': ['/tools/', '/product/'],
    '/nl/producten/': ['/nl/gereedschap/', '/nl/product/'],
};

const normalize = (p) => '/' + (p || '').replace(/^\/+|\/+$/g, '');

export default function initNavIndicator() {
    if (initialized) return;
    initialized = true;

    const nav = document.querySelector('.site-header__nav');
    if (!nav) return;

    const matchesAlias = (itemPath, currentPath) => {
        const aliases = PREFIX_ALIASES[itemPath] || [];
        return aliases.some((prefix) => currentPath.startsWith(prefix));
    };

    const resolveActiveItem = () => {
        const path = normalize(window.location.pathname);
        const items = Array.from(nav.querySelectorAll('li a'));

        // 1. Exacte path-match.
        for (const a of items) {
            try {
                if (normalize(new URL(a.href, window.location.origin).pathname) === path) return a;
            } catch (_) { /* noop */ }
        }

        // 2. Langste prefix-match (item-href of alias). Home telt niet mee.
        let best = null;
        let bestLen = 0;
        for (const a of items) {
            try {
                const itemPath = normalize(new URL(a.href, window.location.origin).pathname);
                if (itemPath === '/' || itemPath === '/nl') continue;
                const hit = path.startsWith(itemPath + '/') || matchesAlias(itemPath + '/', path + '/');
                if (hit && itemPath.length > bestLen) {
                    best = a;
                    bestLen = itemPath.length;
                }
            } catch (_) { /* noop */ }
        }
        return best;
    };

    const syncActiveClass = () => {
        const link = resolveActiveItem();
        // Geen match: laat de server-side WP-classes staan.
        if (!link) return;
        nav.querySelectorAll('li').forEach((li) => {
            STALE_CLASSES.forEach((c) => li.classList.remove(c));
        });
        link.closest('li')?.classList.add('current-menu-item', 'current_page_item');
    };

    syncActiveClass();
    window.addEventListener('irontools:route-change', () => requestAnimationFrame(syncActiveClass));
}
